import { createFileRoute } from "@tanstack/react-router";

import { RoutePage, routeEntry } from "./routeTable";

const entry = routeEntry("/experiments");

export const Route = createFileRoute("/experiments/")({
  head: () => ({
    meta: [
      { title: "Experiments — LevelLoad" },
      {
        name: "description",
        content: "Branch, edit, run and compare planning scenarios before promoting one to live.",
      },
      { property: "og:title", content: "Experiments — LevelLoad" },
      {
        property: "og:description",
        content: "Branch, edit, run and compare planning scenarios before promoting one to live.",
      },
      { property: "og:type", content: "website" },
      { name: "twitter:card", content: "summary_large_image" },
    ],
  }),
  component: RouteComponent,
});

function RouteComponent() {
  return <RoutePage entry={entry} />;
}
